import { Observable, fromEvent, merge } from 'rxjs';
import { map } from 'rxjs/operators';
import { platform } from '../platform';

interface VirtualKeyboardState {
  isOpen: boolean;
  height: number;
  offsetTop: number;
}

export const observeVirtualKeyboard = (): Observable<VirtualKeyboardState> => {
  if (!window.visualViewport || !platform.isMobile) {
    return new Observable((subscriber) => {
      subscriber.next({ isOpen: false, height: 0, offsetTop: 0 });
    });
  }

  const resize$ = fromEvent(window.visualViewport, 'resize');
  const scroll$ = fromEvent(window.visualViewport, 'scroll');

  return merge(resize$, scroll$).pipe(
    map(() => {
      const viewportHeight = window.innerHeight;
      const visualViewportHeight = window.visualViewport!.height ?? viewportHeight;
      const height = viewportHeight - visualViewportHeight;
      const isOpen = height > 0;
      const offsetTop = window.visualViewport!.offsetTop ?? 0;

      return { isOpen, height, offsetTop };
    }),
  );
};
